// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3vvUb","row":"Node_row__qp9xD","label":"Node_label__2gkIj","footer":"Node_footer__33X5D"};